import MarkdownIt from "markdown-it";
import DOMPurify from "dompurify";

const md = new MarkdownIt({
  html: false,
  linkify: true,
  typographer: true,
  breaks: true,
});

export function useMarkdown() {
  /**
   * Render markdown text to sanitized HTML
   * @param {string} text - The markdown text to render
   * @returns {string} Sanitized HTML string
   */
  const renderMarkdown = (text) => {
    if (!text) return "";
    const rendered = md.render(text);
    return DOMPurify.sanitize(rendered, {
      ADD_ATTR: ["target"],
      ALLOWED_TAGS: [
        "p",
        "br",
        "strong",
        "em",
        "u",
        "a",
        "ul",
        "ol",
        "li",
        "code",
        "pre",
        "h1",
        "h2",
        "h3",
        "h4",
        "h5",
        "h6",
        "blockquote",
        "hr",
        "table",
        "thead",
        "tbody",
        "tr",
        "th",
        "td",
      ],
    });
  };

  /**
   * Copy markdown text to the clipboard as both rich HTML and plain text
   * @param {string} text - The markdown text to copy
   */
  const copyMarkdownToClipboard = async (text) => {
    const html = renderMarkdown(text);

    const el = document.createElement("div");
    el.innerHTML = html;
    el.style.cssText = "position:absolute;left:-99999px";
    document.body.appendChild(el);
    const plain = el.innerText;
    document.body.removeChild(el);

    await navigator.clipboard.write([
      new ClipboardItem({
        "text/html": new Blob([html], { type: "text/html" }),
        "text/plain": new Blob([plain], { type: "text/plain" }),
      }),
    ]);
  };

  return { renderMarkdown, copyMarkdownToClipboard };
}
